import { Checkbox, FormControlLabel, Stack } from '@mui/material'
import { DateTimePicker } from '@mui/x-date-pickers-pro'
import dayjs from 'dayjs'

import { dedupArray } from '../../utils/dedupArray/dedupArray'
export type ReminderTimeType = 'immediate' | 'hour' | 'day' | 'week' | 'custom'
export const reminderTimeTypeDescription: {
  [key in ReminderTimeType]: string
} = {
  immediate: 'Immediately',
  hour: '1 hour before',
  day: '1 day before',
  week: '1 week before',
  custom: 'Custom'
}
export const SelectReminderTime = ({
  appointmentTime,
  scheduledDateTimes,
  setScheduledDateTimes,
  customDateTime,
  setCustomDateTime
}: {
  appointmentTime: Date
  scheduledDateTimes: ReminderTimeType[]
  setScheduledDateTimes: (scheduledDateTime: ReminderTimeType[]) => void
  customDateTime: Date
  setCustomDateTime: (dateTime: Date) => void
}) => {
  const today = new Date()
  const hasOneHour = appointmentTime.getTime() - today.getTime() > 3600000
  const hasOneDay = appointmentTime.getTime() - today.getTime() > 86400000
  const hasOneWeek = appointmentTime.getTime() - today.getTime() > 604800000
  const handleChange = (checked: boolean, time: ReminderTimeType) => {
    if (checked) {
      setScheduledDateTimes(
        dedupArray([
          ...scheduledDateTimes,
          time
        ] as string[]) as ReminderTimeType[]
      )
    } else {
      setScheduledDateTimes(scheduledDateTimes.filter((v) => v !== time))
    }
  }
  return (
    <Stack>
      <FormControlLabel
        control={
          <Checkbox
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              handleChange(event.target.checked, 'immediate')
            }}
            checked={scheduledDateTimes.includes('immediate')}
          />
        }
        label={reminderTimeTypeDescription.immediate}
      />
      {hasOneHour && (
        <FormControlLabel
          control={
            <Checkbox
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                handleChange(event.target.checked, 'hour')
              }}
              checked={scheduledDateTimes.includes('hour')}
            />
          }
          label={reminderTimeTypeDescription.hour}
        />
      )}
      {hasOneDay && (
        <FormControlLabel
          control={
            <Checkbox
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                handleChange(event.target.checked, 'day')
              }}
              checked={scheduledDateTimes.includes('day')}
            />
          }
          label={reminderTimeTypeDescription.day}
        />
      )}
      {hasOneWeek && (
        <FormControlLabel
          control={
            <Checkbox
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                handleChange(event.target.checked, 'week')
              }}
              checked={scheduledDateTimes.includes('week')}
            />
          }
          label={reminderTimeTypeDescription.week}
        />
      )}
      <Stack direction="row" spacing={1} alignItems="center">
        <FormControlLabel
          control={
            <Checkbox
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                handleChange(event.target.checked, 'custom')
              }}
              checked={scheduledDateTimes.includes('custom')}
            />
          }
          label={reminderTimeTypeDescription.custom}
        />
        {scheduledDateTimes.includes('custom') && (
          <DateTimePicker
            disablePast
            slotProps={{ textField: { variant: 'standard' } }}
            label="Reminder Time"
            value={dayjs(customDateTime)}
            onChange={(newValue) => {
              if (newValue) {
                setCustomDateTime(newValue.toDate())
              }
            }}
            sx={{ minWidth: 200 }}
          />
        )}
      </Stack>
    </Stack>
  )
}
